export default {
  "removeItem": "Remove item",
  "addItem": "Add item",
  "invalidClubCodeForInRoomScreenRoute": "Invalid club code for in-room screen route",
  "screenNotProvisionedMissingClubCodeDeviceCode": "Screen not provisioned / missing clubCode / deviceCode",
  "screenNotFound": "Screen not found",
  "unableToStartProvisioning": "Unable to start provisioning",
  "waitingForProvisioning": "Waiting for provisioning...",
  "memberMode": "Member Mode",
  "yourPrivateSanctuary": "Your private sanctuary",
  "communication": "Communication",
  "bookings": "Bookings",
  "diningDrinks": "Dining & Drinks",
  "activities": "Activities",
  "roomService": "Room Service",
  "message": "Message",
  "contactConciergeStaff": "Contact concierge & staff",
  "reservations": "Reservations",
  "viewAndAdjustUpcomingBookings": "View and adjust upcoming bookings",
  "orderDrinks": "Order Drinks",
  "seeOurMenus": "See our menus",
  "planActivities": "Plan Activities",
  "exploreOurAmenities": "Explore our amenities",
  "callFrontDesk": "Call front desk",
  "golfTeeTimes": "Golf tee times",
  "spaRitual": "Spa ritual",
  "fitnessSession": "Fitness session",
  "racquetCourt": "Racquet court",
  "dining": "Dining",
  "signatureCocktails": "Signature cocktails",
  "wineList": "Wine list",
  "inRoomDining": "In-room dining",
  "eventsCalendar": "Events calendar",
  "guidedTours": "Guided tours",
  "wellnessSchedule": "Wellness schedule",
  "localHighlights": "Local highlights",
  "breakfast": "Breakfast",
  "lateNightBites": "Late night bites",
  "housekeepingRequest": "Housekeeping request",
  "welcomeBack": "Welcome back",
  "welcome": "Welcome",
  "messageFrontDesk": "Message front desk",
  "missingClub": "Missing club",
  "unableToPlaceTheCall": "Unable to place the call.",
  "roomUnavailable": "Room unavailable",
  "noRoomIsAssignedToThisScreen": "No room is assigned to this screen.",
  "frontDeskCallingIsntConfiguredYet": "Front desk calling isn’t configured yet.",
  "unableToPlaceCall": "Unable to place call",
  "pleaseTryAgainSoon": "Please try again soon.",
  "callingFrontDesk": "Calling front desk…",
  "connectingYourRequest": "Connecting your request.",
  "unableToHangUp": "Unable to hang up",
  "pleaseTryAgain": "Please try again.",
  "messageFailed": "Message failed",
  "item": "Item",
  "orderPlaced": "Order placed · #",
  "roomServiceHasReceivedYourRequest": "Room service has received your request.",
  "pleaseReviewYourOrderAndTryAgain": "Please review your order and try again.",
  "menuIsNoLongerAvailable": "Menu is no longer available.",
  "orderRetryConflictPleaseTryAgain": "Order retry conflict. Please try again.",
  "unableToPlaceOrder": "Unable to place order",
  "pleaseTryAgainInAMoment": "Please try again in a moment.",
  "room": "Room",
  "deviceDisabled": "Device disabled",
  "thisScreenIsDisabledAskStaffToEnableItInTheClubPortal": "This screen is disabled. Ask staff to enable it in the club portal.",
  "screenAlreadyPaired": "Screen already paired",
  "thisScreenIsAlreadyPairedToClub": "This screen is already paired to club",
  "device": ", device",
  "openInRoomScreen": "Open In-Room Screen",
  "pairAnotherScreen": "Pair another screen",
  "screenProvisioning": "Screen Provisioning",
  "installID": "Install ID:",
  "shareThisCodeWithClubStaffToClaimThisScreen": "Share this code with club staff to claim this screen.",
  "expiresIn": "Expires in",
  "staffInstructions": "Staff instructions",
  "openTheClubPortalRoomsInRoomScreens": "Open the club portal > Rooms > In-Room Screens.",
  "clickAddScreenAndEnterThisCode": "Click “Add screen” and enter this code.",
  "selectTheRoomToAssignAndSubmit": "Select the room to assign and submit.",
  "status": "Status:",
  "waitingForAClubAdminToClaimThisScreenTheDisplayWillAutomaticallyContinueOnceAssigned": "Waiting for a club admin to claim this screen. The display will automatically continue once assigned.",
  "suiteBackdrop": "Suite backdrop",
  "privacy": "Privacy",
  "home": "Home",
  "wellNotifyYouWhenItsReady": "We'll notify you when it's ready.",
  "memberPortal": "Member portal",
  "bookingsMessagingAndSchedulesStayAvailable": "Bookings, messaging, and schedules stay available.",
  "backToHome": "Back to home",
  "signOutOnThisScreen": "Sign out on this screen",
  "memberPortalModulesRenderHereInProductionThisPlaceholderKeepsTheLayoutConsistentWhileThePairingSessionIsActive": "Member portal modules render here in production. This placeholder keeps the layout consistent while the pairing session is active.",
  "bookingShortcuts": "Booking shortcuts",
  "messagesConcierge": "Messages & concierge",
  "liveChatWithTheFrontDeskTeam": "Live chat with the front desk team.",
  "back": "Back",
  "typeYourMessage": "Type your message…",
  "send": "Send",
  "refinedOptionsCuratedForYourStay": "Refined options curated for your stay.",
  "inCallWithFrontDesk": "In call with front desk",
  "callEnded": "Call ended",
  "tapToContinue": "Tap to continue",
  "enter": "Enter",
  "hangUp": "Hang up",
  "confirmRoomServiceOrder": "Confirm room service order",
  "reviewYourItemsBeforePlacingTheOrder": "Review your items before placing the order.",
  "subtotal": "Subtotal",
  "deliveryFee": "Delivery fee",
  "total": "Total",
  "cancel": "Cancel",
  "placingOrder": "Placing order…",
  "confirmOrder": "Confirm order",
  "pairDevice": "Pair device",
  "syncWithYourPhone": "Sync with your phone",
  "pairingCode": "Pairing code",
  "menus": "Menus",
  "loadingMenus": "Loading menus…",
  "noRoomServiceMenusAvailable": "No room service menus available.",
  "items": "Items",
  "loadingItems": "Loading items…",
  "basket": "Basket",
  "noItemsYet": "No items yet.",
  "placeOrder": "Place order",
  "loading": "loading...",
  "requested": "requested",
  "confirmed": "confirmed",
  "preparing": "preparing",
  "ready": "ready",
  "delivered": "delivered",
  "cancelled": "cancelled"
};
